console.log(window.location.origin);
let origin = window.location.origin;

let loginAddress = `${origin}/auth/joshid`;
let logoutAddress = "";
let changePasswordAddress = ''

if (process.env.NODE_ENV === "development") {
  loginAddress = 'http://loantest.yimeijian.cn/auth/joshid';
  logoutAddress = "http://accounttest.yimeijian.cn/sessions/confirm_sign_out";
  changePasswordAddress='http://accounttest.yimeijian.cn/#/admins/change_password';
} else {
  logoutAddress = "http://account.yimeijian.cn/sessions/confirm_sign_out";
  changePasswordAddress='http://account.yimeijian.cn/#/admins/change_password';

  if (origin.includes("test")) {
    logoutAddress = "http://accounttest.yimeijian.cn/sessions/confirm_sign_out";
    changePasswordAddress='http://accounttest.yimeijian.cn/#/admins/change_password';

  }
}
export function getToken() {
  return localStorage.getItem("X-YMJ-Token");
}

export function setToken(token) {
  return localStorage.setItem("X-YMJ-Token", token);
}
export function deleteToken(token) {
  return localStorage.removeItem("X-YMJ-Token");
}

export function getEmail() {
  return localStorage.getItem("X-YMJ-Email");
}

export function setEmail(email) {
  return localStorage.setItem("X-YMJ-Email", email);
}

export function deleteEmail() {
  return localStorage.removeItem("X-YMJ-Email");
}

export function isLogin() {
  return !!(getToken() && getEmail());
}

export function gotLogin() {
  window.location.href = loginAddress;
}

export function goLoginOut(loginout_url) {
  const search = `?redirect_url=${loginAddress}`;
  const logoutUrl = `${logoutAddress}${search}`;

  window.location.href = logoutUrl;
}

export function changePassword() {
  window.location.href = changePasswordAddress;
}
export function haveAuthority(nowAuthority, pathAuthority) {
  if (!pathAuthority) {
    return true;
  }
  if (Array.isArray(pathAuthority)) {
    return pathAuthority.includes(nowAuthority);
  }
  if (pathAuthority.constructor === String) {
    return nowAuthority === pathAuthority;
  }
  throw new Error("haveAuthority传入参数错误");
}



// WEBPACK FOOTER //
// ./src/utils/authority.js